module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity-new/flat-lays/flat-lay-02-e380010d6ffe6b99d65ec36b3bf3189c.jpg";